/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overall_Score_LabelInputs */

const en_overall_score_label = /** @type {(inputs: Overall_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall score`)
};

const de_overall_score_label = /** @type {(inputs: Overall_Score_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtscore`)
};

/**
* | output |
* | --- |
* | "Overall score" |
*
* @param {Overall_Score_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const overall_score_label = /** @type {((inputs?: Overall_Score_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overall_Score_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_overall_score_label(inputs)
	return en_overall_score_label(inputs)
});